import { useState } from "react";
import { navItems } from "@/mocks/homeData";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="relative mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            黑料社区
          </h1>
        </a>

        <nav className="absolute left-1/2 hidden -translate-x-1/2 items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="relative hidden items-center md:flex">
            <span className="pointer-events-none absolute left-3 flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              type="text"
              placeholder="搜索话题 / 标签"
              className="h-9 w-36 rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 lg:w-48"
            />
          </div>
          <a
            href="#download"
            className="hidden h-9 items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-2-line"></i>
            </span>
            下载 App
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((value) => !value)}
            aria-label="展开导航菜单"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex items-center gap-2">
            <div className="relative flex flex-1 items-center">
              <span className="pointer-events-none absolute left-3 flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </span>
              <input
                type="text"
                placeholder="搜索话题 / 标签"
                className="h-10 w-full rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm text-foreground-800 outline-none focus:border-primary-400"
              />
            </div>
            <a
              href="#download"
              onClick={() => setMenuOpen(false)}
              className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 text-sm font-medium text-background-50"
            >
              <i className="ri-download-2-line"></i>
              下载
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}